import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconDashboard(props: SvgIconProps) {
  return (
    <SVGIcon width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M7.5 2.5H2C1.72386 2.5 1.5 2.72386 1.5 3V6.5H7.5V2.5Z" fill="white" stroke="currentColor" />
      <path d="M10 2.5H7.5V6.5H10.5V3C10.5 2.72386 10.2761 2.5 10 2.5Z" fill="white" stroke="currentColor" />
      <path d="M4.5 6.5H1.5V9C1.5 9.27614 1.72386 9.5 2 9.5H4.5V6.5Z" fill="white" stroke="currentColor" />
      <path d="M7.5 6.5H4.5V9.5H7.5V6.5Z" fill="white" stroke="currentColor" />
      <path d="M10.5 6.5H7.5V9.5H10C10.2761 9.5 10.5 9.27614 10.5 9V6.5Z" fill="white" stroke="currentColor" />
    </SVGIcon>
  );
}
